import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { LoadMoreButtonProps } from './types';

const LoadMoreButton = ({ totalItemsCount, hasMoreItems, onLoadMore }: LoadMoreButtonProps) => {
  const { t } = useTranslation('inboxes');
  const [isLoading, setIsLoading] = useState(false);

  // Si pas d'éléments ou plus d'éléments à charger, on n'affiche rien
  if (totalItemsCount === 0 || !hasMoreItems) {
    return null;
  }

  const handleClick = async () => {
    if (isLoading) return; // Prevent multiple clicks
    setIsLoading(true);
    try {
      await onLoadMore();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 2,
        padding: 2,
      }}
    >
      <Button variant="contained" onClick={handleClick} disabled={isLoading}>
        {isLoading ? t('loading') : t('load_more')}
      </Button>
    </Box>
  );
};

export default observer(LoadMoreButton);
